export default "__VITE_ASSET__KP6_rtrw__"